export default __webpack_public_path__ + "609f467c8aefe88c2e6aa2fc64c5ed88.svg";